// Abmelden aus der Hülle (Benutzer-Menü, Befehlspalette, Wahl des Betriebs): erst die Abmelde-Wächter fragen
// (docs/kasse-offline/SPEZIFIKATION.md §12.2, §14.7). Sperrt einer, zeigt die Hülle seinen Satz statt abzumelden.
import { logout, logoutBlockedReason } from '../stores/session'
import { toast } from '../ui/Toast'

const BLOCKED_TOAST_ID = 'logout-blocked'

/**
 * true = abgemeldet (auch wenn der Server nicht antwortete), false = ein Wächter sperrt; dann steht sein Satz als
 * Hinweis da und nichts ist geschehen. `then` läuft nur nach dem Abmelden (z. B. zur Anmeldeseite wechseln).
 */
export async function signOut(then?: () => void): Promise<boolean> {
  const blocked = logoutBlockedReason()
  if (blocked) {
    toast.show({ id: BLOCKED_TOAST_ID, title: blocked, tone: 'warning' })
    return false
  }
  const done = await logout().catch(() => true)
  if (!done) {
    toast.show({ id: BLOCKED_TOAST_ID, title: logoutBlockedReason() ?? 'Abmelden ist gerade nicht möglich.', tone: 'warning' })
    return false
  }
  then?.()
  return true
}
